var getNative = require('./_getNative');

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;



//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/lodash/_defineProperty.js
// module id = 1493
// module chunks = 3 9 13